

export class LicenseToDriveOutputWithStatus implements ILicenseToDriveOutputWithStatus {
    /** The auto-generated id of the license to drive master */
    license_to_drive_id!: number;
    /** The license to drive name with 255 character limit */
    license_to_drive_name!: string;
    /** Manage status of license to drive name. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ILicenseToDriveOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.license_to_drive_id = _data["license_to_drive_id"];
            this.license_to_drive_name = _data["license_to_drive_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LicenseToDriveOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseToDriveOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["license_to_drive_id"] = this.license_to_drive_id;
        data["license_to_drive_name"] = this.license_to_drive_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface ILicenseToDriveOutputWithStatus {
    /** The auto-generated id of the license to drive master */
    license_to_drive_id: number;
    /** The license to drive name with 255 character limit */
    license_to_drive_name: string;
    /** Manage status of license to drive name. 0 For De-active, 1 For Active */
    status: number;
}

